import * as Actions from '../actions';

const initialState = {
    success: false,
    error  : {
        username: null,
        password: null,
        email: null
    }
};

const register = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.REGISTER_SUCCESS:
        {
            return {
                ...initialState,
                success: true
            };
        }
        case Actions.REGISTER_ERROR:
        {
            return {
                success: false,
                error  : action.payload
            };
        }
        case Actions.CHECK_SESSION_KEY:
            console.log(action.payload)
        {
            return {
                ...initialState
            }
        }
        default:
        {
            return state
        }
    }
};

export default register;


// WEBPACK FOOTER //
// src/auth/store/reducers/register.reducer.js